import {IResetPasswordData} from '../../api/api.types';
import {IUserApi} from '../../api/user-api.service';
import {StateService} from 'angular-ui-router';

export default class ResetPasswordController {
	static $inject = ['userApi', '$state', '$location', '$mdDialog'];

	private resetPasswordData: IResetPasswordData;

	constructor (
		private userApi: IUserApi,
		private $state: StateService,
		private $location: ng.ILocationService,
		private $mdDialog: ng.material.IDialogService) {
	}

	private onResetPasswordClick($event: MouseEvent) {
		this.resetPasswordData.token = this.$location.search().token;
		this.userApi.resetPassword(this.resetPasswordData)
			.then(() => {
				this.$state.go('home');
			}, (errorData) => {
				this.$mdDialog.show(
				    this.$mdDialog.alert()
				        .clickOutsideToClose(true)
				        .title('')
				        .textContent(errorData.data.details)
				        .ok('OK')
				);
			});
	}
}


/** WEBPACK FOOTER **
 ** ./app/hydromet/resetPassword/reset-password.controller.ts
 **/